import { Paper } from '@mui/material';
import { useQuery } from 'react-query';
import RestHttpClient from '../../../../common/RestHttpClient';
import { useContext } from 'react';
import { ClassificationContext } from '../../context/ClassificationContext.types';
import { EnhancedTable } from '../../../../common/table/EnhancedTable';
import { useTranslation } from 'react-i18next';
import { HeadCell } from '../../../../common/table/EnhancedTableHead';
import { useNavigate } from 'react-router';

interface ClassifiedObjectRow {
  id: string;
  objectType: string;
  groupName: string;
}

export function GroupObjectList() {
  const { t } = useTranslation();

  const { selectedGroup } = useContext(ClassificationContext);

  const navigate = useNavigate();

  const { data = [], isLoading } = useQuery({
    queryKey: ['classification', 'objects', selectedGroup?.id],
    queryFn: () => RestHttpClient.getClassificationGroupObjects(selectedGroup?.id),
    select: (x) => x.data,
    enabled: !!selectedGroup,
  });

  const headCells: readonly HeadCell<ClassifiedObjectRow>[] = [
    {
      id: 'id',
      disablePadding: false,
      label: t('classification.classifiedObject.id'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'objectType',
      disablePadding: false,
      label: t('classification.classifiedObject.type'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'groupName',
      disablePadding: false,
      label: t('classification.classifiedObject.groupName'),
      allowSorting: true,
      allowFiltering: true,
    },
  ];

  const handleRowClick = (e: React.MouseEvent<unknown>, id: string) => {
    e.stopPropagation();

    const objectLink = data.find((x) => x.objectId === id);
    if (objectLink) {
      navigate(`/classification/objects/${objectLink.objectId}/${objectLink.objectType}`);
    }
  };

  const rows = data.map((x) => ({
    id: x.objectId,
    groupName: x.groupName,
    objectType: t(`classification.classifiedObject.types.${x.objectType}`),
  }));

  return (
    <Paper sx={{ width: '100%', mb: 2 }}>
      <EnhancedTable
        rows={rows}
        loading={isLoading}
        headCells={headCells}
        hideCheckbox={true}
        variant="default"
        onRowClick={handleRowClick}
      />
    </Paper>
  );
}
